import {Grid} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { useUpdateEffect } from "../../../../utils/common";
import AutocompleteInput from "../atoms/AutocompleteInput";

/* This component shouldn't be required but AutocompleteInput doesn't correctly keep typed input
*  and only can track a value if its selected. This is a workaround, to track typed input as well as selected values,
*  as I am not sure where else AutocompleteInput is used. */
export default function StartsWithInput(props) {
  const {values, filterOptions, columnOptions, optionsDict, disabled} = props;
  const {onValueChange, searchDebounce} = props;
  const {selectedValue, selectedField, selectedOperator, selectedFieldId, setSelectedFieldId} = props;
  const {loading, nonManagerDetail} = props;

  const parsedSelectedValue = selectedValue[0]?.id;
  const [startText, setStartText] = useState(parsedSelectedValue);
  const [startSelectedValue, setStartSelectedValue] = useState([{label: parsedSelectedValue, id: parsedSelectedValue}]);
  const [startFinal, setStartFinal] = useState(parsedSelectedValue);

  /* Component is setup in this way because of how the parent component was built:
  *   1. text HAS to be a string
  *   2. selectedValue HAS to be an array of object(s) */
  useUpdateEffect(() => {
    setStartFinal(startSelectedValue[0]?.id ?? "");
  }, [startSelectedValue]);
  useUpdateEffect(() => {
    setStartFinal(startText ?? "");
  }, [startText]);
  useUpdateEffect(() => {
    onValueChange(null, {id: `${startFinal}`});
  }, [startFinal]);

  return (
    <Grid container data-testid="starts-with-input" style={{width: "300px", display: "flex"}}>
      <AutocompleteInput
        disabled={disabled}
        styles={{flex: 1, width: "100%"}}
        values={values}
        filterOptions={filterOptions}
        columnOptions={columnOptions}
        optionsDict={optionsDict}
        onValueChange={(event, value) => setStartSelectedValue([{label: value?.label ?? "", id: value?.id ?? ""}])}
        searchDebounce={searchDebounce}
        selectedValue={startSelectedValue}
        selectedField={selectedField}
        selectedOperator={selectedOperator}
        selectedFieldId={selectedFieldId}
        setSelectedFieldId={setSelectedFieldId}
        loading={loading}
        nonManagerDetail={nonManagerDetail}
        text={startText}
        setText={(text) => {
          setStartText(text);
        }}
      />
    </Grid>
  );
}
